import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { onDownloadClick } from '../../functions/functions';
import { faDownload } from '@fortawesome/free-solid-svg-icons';
import { CellRenderEvent } from '../../interfaces/interfaces';

const downloadLink = (url: string | null | undefined, msg?: React.ReactNode): React.ReactNode => {
    if (!url) {
        return msg;
    }
    return (
        <button
            className='gridButton'
            onClick={(event) => onDownloadClick(event, url)}
        >
            <FontAwesomeIcon icon={faDownload} />
        </button>
    );
};

export const onFileRender = (e: CellRenderEvent): React.ReactNode => {
    if (!e.value) {
        return null;
    }
    return downloadLink(e.value as string);
};
